import {combineReducers} from '@reduxjs/toolkit';
import {projects} from './projects';
import {reasons} from './reasons';

export const settings = combineReducers({projects, reasons});
